// Single source of truth for who runs NORYQ and which version of the legal
// documents is live. Change it here and every page and consent record follows.
//
// When you change the Terms, Privacy Policy, Cookie Policy or Refund Policy in a
// meaningful way: update LAST_UPDATED and POLICY_VERSION together.

export const OPERATOR = {
  brand: "NORYQ",
  website: "https://noryq.in",
  name: "Harsh Yadav",
  status: "an individual running NORYQ as a sole proprietor",
  address: "26, Janak Puri, MR-10, Sukhliya, Indore, Madhya Pradesh, India",
  email: "noryq.official@gmail.com",
};

export const POLICY_VERSION = "2026-10-01";
export const LAST_UPDATED = "1 October 2026";

// Grievance Officer (IT Rules 2021; also serves as the DPDP grievance contact).
export const GRIEVANCE = {
  name: "Harsh Yadav",
  designation: "Grievance Officer and Data Protection Contact",
  email: OPERATOR.email,
  address: OPERATOR.address,
  acknowledgeWithin: "24 hours",
  resolveWithin: "15 days",
};
